function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import { ContextPanelReactProps } from 'common/widgets/context-panel';
import { eventPrefix as shareEventPrefix, ShareButtonUISource, track as shareTrack } from 'common/widgets/sharing/tracking';
import { EntityTypeNameSingular, SharableEntityType } from 'common/report/util/saved-entities/types';
import { currentProjectStore } from 'common/report/stores/project-details';
import { promptSharing } from 'common/widgets/sharing';
import { getProjectId, getWorkspaceId } from 'common/report/util';
import { eventDefinitionsStore } from 'common/report/stores/event-definitions';
import { promptCustomEvents } from 'common/widgets/custom-event-modal/utils';
import { openEventsSidebar } from 'common/widgets/events-sidebar';
import { ProjectFeatureFlag } from 'common/report/constants';
import { addToast } from 'common/components/toast-area/toast-manager';
import { ActionType } from 'common/widgets/context-panel/types';
import { updateEntityDescription } from '../utils/util';
import { TRACKING_EVENTS } from '../constants';
import type { ContextPanelRendererParams } from '../child-menu';
import { getCustomEventMenuItem } from '../contexts/events-controller';
export const createContextPanelEventHandlers = (_ref: Partial<ContextPanelRendererParams>): Partial<ContextPanelReactProps> => {
  let {
    track,
    handleSelect,
    handleDelete,
    additionalArgs = {},
    handleHoverIn = null,
    handleHoverOut = null
  }: Partial<ContextPanelRendererParams> = _ref;
  // handles actions from, the context panel
  const handleContextPanelAction = async (ev: CustomEvent) => {
    if (ev.detail.name === ActionType.EditCustomEvent) {
      const {
        appliedValue: customEvent,
        deletedId
      } = await promptCustomEvents({
        attrs: {
          open: true,
          'all-data-groups': additionalArgs["all-data-groups"],
          'project-has-people': additionalArgs["project-has-people"],
          'project-id': getProjectId(),
          'workspace-id': getWorkspaceId(),
          'track-name': additionalArgs["track-name"],
          'selected-custom-event-id': ev.detail.item.id
        },
        params: {}
      });
      if (customEvent) {
        handleSelect({
          item: getCustomEventMenuItem(customEvent).value
        });
      } else if (deletedId) {
        handleDelete({
          id: deletedId
        });
      }
    } else if (ev.detail.name === ActionType.ShareCustomEvent) {
      const {
        eventName,
        props
      } = shareTrack.shareButtonClick(ShareButtonUISource.ContextPanel);
      track(eventName, props, false, shareEventPrefix);
      promptSharing({
        type: SharableEntityType.CustomEvent,
        id: ev.detail.item.id,
        'project-id': parseInt(getProjectId(), 10),
        'is-superadmin': ev.detail.item.superadminOverrideShare
      });
    } else if (ev.detail.name === ActionType.ViewSampleEvents && ev.detail.item.url) {
      var _currentProjectStore$;
      track(TRACKING_EVENTS.SAMPLE_EVENT, {}, false);
      if ((_currentProjectStore$ = currentProjectStore.value) !== null && _currentProjectStore$ !== void 0 && _currentProjectStore$.hasFeatureFlag(ProjectFeatureFlag.EventsSidebar)) {
        openEventsSidebar({
          url: ev.detail.item.url
        });
      } else {
        window.open(ev.detail.item.url, "_blank");
      }
    } else if (ev.detail.name === ActionType.ViewEntity && ev.detail.item.url) {
      window.open(ev.detail.item.url, "_blank");
    }
  };
  const handleContextPanelEditDescription = async (_ref2: CustomEvent) => {
    var _definition$descripti;
    let {
      detail
    }: CustomEvent = _ref2;
    const eventStoreKey = detail.item.name;
    const IdName = detail.item.type === EntityTypeNameSingular.Event ? "id" : "customEventId";
    const definition = eventDefinitionsStore.value[eventStoreKey];
    const descriptionBeforeUpdate = (_definition$descripti = definition === null || definition === void 0 ? void 0 : definition.description) !== null && _definition$descripti !== void 0 ? _definition$descripti : null;
    const count = (definition === null || definition === void 0 ? void 0 : definition.count) || 0;
    let eventDefinition = {
      [IdName]: detail.item.id,
      description: detail.description
    };
    if (!detail.item.id) {
      eventDefinition = {
        name: detail.item.name,
        description: detail.description
      };
    }
    const updateRequestObj = {
      projectId: getProjectId(),
      workspaceId: getWorkspaceId(),
      eventDefinition
    };
    const undoRequestObj = _objectSpread(_objectSpread({}, updateRequestObj), {}, {
      eventDefinition: _objectSpread(_objectSpread({}, updateRequestObj.eventDefinition), {}, {
        description: descriptionBeforeUpdate
      })
    });
    await updateEntityDescription({
      entityStore: eventDefinitionsStore,
      newDescription: detail.description,
      storeKey: eventStoreKey,
      updateRequestObj,
      undoRequestObj,
      entityType: detail.item.type,
      addToast,
      track
    });
    eventDefinitionsStore.update({
      [eventStoreKey]: _objectSpread(_objectSpread({}, eventDefinitionsStore.value[eventStoreKey]), {}, {
        count
      })
    });
  };
  return {
    onHoverIn: handleHoverIn,
    onHoverOut: handleHoverOut,
    onTooltipContextAction: handleContextPanelAction,
    onTooltipContextEditDescription: handleContextPanelEditDescription
  };
};